import { Alert } from '@/ui/molecules/alert/Alert'

export function NoActionsView() {
  return <Alert variant="info">No actions available. All required actions have been completed or are not needed.</Alert>
}
